<template>
  <div class="password-layout">
    <el-form ref="form"
             size="mini"
             label-position="top"
             label-suffix="："
             :model="form">
      <el-form-item v-if="original"
                    label="原密码"
                    prop="oldPassword"
                    :rules="oldPasswordRules">
        <PasswordField v-model="form.oldPassword"
                       maxlength="20"></PasswordField>
      </el-form-item>
      <el-form-item label="新密码"
                    prop="newPassword"
                    :rules="newPasswordRules">
        <PasswordField v-model="form.newPassword"
                       maxlength="20"></PasswordField>
      </el-form-item>
      <el-form-item label="确认密码"
                    prop="confirmPassword"
                    :rules="confirmPasswordRules">
        <PasswordField v-model="form.confirmPassword"
                       maxlength="20"></PasswordField>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import PasswordField from '../elements/PasswordField'
export default {
  name: 'PasswordLayout',
  components: {
    PasswordField
  },
  props: {
    original: Boolean,
    complex: Boolean
  },
  data () {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    oldPasswordRules () {
      return {
        validator: (rule, value, callback) => {
          if (value) {
            callback()
          } else {
            callback(new Error('请输入原密码'))
          }
        },
        trigger: 'blur'
      }
    },
    newPasswordRules () {
      return {
        validator: (rule, value, callback) => {
          if (this.complex) {
            let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[0-9A-Za-z]{8,20}$/
            if (regex.test(value)) {
              callback()
            } else {
              callback(new Error('密码需包含大小写字母和数字，长度8-20位'))
            }
          } else {
            let regex = /^.{6,20}$/
            if (regex.test(value)) {
              callback()
            } else {
              callback(new Error('密码为长度6-20位的任意字符'))
            }
          }
        },
        trigger: 'blur'
      }
    },
    confirmPasswordRules () {
      return {
        validator: (rule, value, callback) => {
          if (this.form.newPassword) {
            if (value === this.form.newPassword) {
              callback()
            } else {
              callback(new Error('两次密码输入不一致'))
            }
          } else {
            callback(new Error('请先输入新密码'))
          }
        },
        trigger: 'blur'
      }
    }
  },
  methods: {
    getPassword () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.original) {
              resolve({
                oldPassword: this.$md5(this.form.oldPassword),
                newPassword: this.$md5(this.form.newPassword)
              })
            } else {
              resolve({
                newPassword: this.$md5(this.form.newPassword)
              })
            }
          } else {
            reject(new Error('请先完善表单'))
          }
        })
      })
    },
    resetPassword () {
      this.$refs.form.resetFields()
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    }
  }
}
</script>

<style lang="scss">
  .password-layout {
    .el-form {
      & > .el-form-item {
        margin-bottom: 10px;
        .el-form-item__label {
          color: #909399;
          font-size: 12px;
          padding-bottom: 0;
        }
        .el-form-item__content {
          font-size: 12px;
        }
      }
    }
  }
</style>
